import { render } from "./wfm-docpicker.vue?vue&type=template&id=472f0eb2&scoped=true"
import script from "./wfm-docpicker.vue?vue&type=script&lang=js"
export * from "./wfm-docpicker.vue?vue&type=script&lang=js"

import "./wfm-docpicker.vue?vue&type=style&index=0&id=472f0eb2&lang=css"
import "./wfm-docpicker.vue?vue&type=style&index=1&id=472f0eb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472f0eb2"]])

export default __exports__